import { useUpdateEffect } from '@cian/react-utils';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectChatsLinkError } from '../../../selectors/alertSelector';
import { selectIsNewChatFromLinkOpened } from '../../../selectors/newChatFromLinkOpenedSelector';
import { useApplicationContext } from '../../../utils/applicationContext';
import { CHATS_RELATIVE_URL } from '../../../constants/chatsRelativeUrl';

/**
 * @description
 * Изменяет урл на /dialogs/, если:
 * - есть ошибка при резолве ссылки /new-chat/
 * - пользователь перешел по ссылке /new-chat/, но не авторизован
 * - пользователь открыл новый чат по ссылке /new-chat/, а потом ушел с него
 */
export const useChatsLinkReplace = () => {
  const chatsLinkError = useSelector(selectChatsLinkError);
  const isNewChatFromLinkOpened = useSelector(selectIsNewChatFromLinkOpened);
  const {
    custom: { chatsLinkToken },
  } = useApplicationContext();

  useEffect(() => {
    if (chatsLinkError || chatsLinkToken) {
      replaceUrlToChats();
    }
  }, [chatsLinkError, chatsLinkToken]);

  useUpdateEffect(() => {
    if (!isNewChatFromLinkOpened) {
      replaceUrlToChats();
    }
  }, [isNewChatFromLinkOpened]);
};

function replaceUrlToChats() {
  window.history.replaceState(null, '', CHATS_RELATIVE_URL);
}
